<template>
    <div v-if="showModal" id="stock_new_modal" class="ui middle aligned center aligned grid">
        <div class="ui column segments">
            <div id="header" class="ui left aligned segment">
                <h3 class="ui header">{{ center.name + " " + constantNames[type] + " (" + partner.name + ")" }}</h3>
            </div>
            <div id="body" class="ui segment">
                <table class="ui very basic table">
                    <thead>
                        <tr>
                            <th class="collapsing">상품명</th>
                            <th class="collapsing">재고수량</th>
                            <th class="collapsing">최종수량</th>
                            <th>수량</th>
                            <th>메모</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(product, index) in products" :key="index">
                            <td class="collapsing">{{ product.name }}</td>
                            <td class="collapsing">{{ product.stock }}</td>
                            <td class="collapsing">
                                {{ product.stock + ((type == constant.STOCK_ADD) ? product.count : -product.count) }}
                            </td>
                            <td>
                                <div class='ui fluid small input'>
                                    <input type="number" v-model.number="product.count" @change="onCountChange">
                                </div>
                            </td>
                            <td>
                                <div class='ui fluid small input'>
                                    <input type="text" v-model="product.memo" placeholder="메모를 입력하세요">
                                </div>
                            </td>
                            <td class="right collapsing">
                                <div class="ui small basic icon buttons">
                                    <button class="ui button" @click="removeProduct(product)">
                                        <i class="times icon"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="ui fluid search selection dropdown" id="product_dropdown">
                    <input type="hidden">
                    <i class="dropdown icon"></i>
                    <div class="default text">상품 추가</div>
                    <div class="menu">
                        <div class="item" v-for="p in partnerProducts" :key="p._id">
                            {{ p.name }}
                        </div>
                    </div>
                </div>
            </div>
            <div id="footer" class="ui right aligned segment">
                <div class="ui text menu">
                    <div class="right menu">
                        <div class="item" v-if="isUploadReady">
                            <input type="file" @change="loadExcelFile">
                        </div>
                        <div class="item" v-if="products.length > 0">
                            <div class="ui primary left labeled icon button" @click="save">
                                <i class="checkmark icon"></i>등록
                            </div>
                        </div>
                        <div class="item">
                            <div class="ui button" @click="close">닫기</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            showModal: 0,
            type: 0,
            partner: 0,
            partnerProducts: 0,
            center: 0,
            products: 0,
            onChange: 0,
            isUploadReady: 0,
        }
    },
    created: function() {
        this.showModal = false;
    },
    mounted: function() {
        window.addEventListener('keyup', (e) => { if (this.showModal && e.keyCode === 27) this.close(); });
        this.$event.set("newStockOrder_add", this.openAdd);
        this.$event.set("newStockOrder_remove", this.openRemove);
    },
    beforeDestroyed: function() {
        this.$event.clear("newStockOrder_add");
        this.$event.clear("newStockOrder_remove");
    },
    methods: {
        reloadFile() {
            this.isUploadReady = false;
            this.$nextTick(() => this.isUploadReady = true);
        },
        openAdd(center, partner, partnerProducts, onChange) {
            this.open(this.constant.STOCK_ADD, center, partner, partnerProducts, onChange);
        },
        openRemove(center, partner, partnerProducts, onChange) {
            this.open(this.constant.STOCK_REMOVE, center, partner, partnerProducts, onChange);
        },
        open(type, center, partner, partnerProducts, onChange) {
            this.showModal = true;
            this.type = type;
            this.center = center;
            this.partner = partner;
            this.partnerProducts = partnerProducts;
            this.onChange = onChange;
            this.products = [];
            this.reloadFile();
            this.$nextTick(() => {
                this.$ui.dropdown("#product_dropdown", (value) => {
                    this.addProduct(value.toUpperCase(), 1);
                });
            });
        },
        close() {
            this.showModal = false;
        },
        save() {
            if (this.products.length > 0) {
                this.$event.call("openLoading");
                this.$api.newStockOrder(this.partner._id, this.center._id, this.type, this.products, (resData) => {
                    this.$event.call("closeLoading");
                    if (resData.error) {
                        alert(resData.error.message);
                    } else {
                        this.close();
                        if (this.onChange) this.onChange();
                    }
                });
            }
        },
        onCountChange() {
            this.$forceUpdate();
        },
        findProduct(name) {
            for (const p of this.partnerProducts)
            {
                if (!p.centerStocks[this.center._id])
                {
                    p.centerStocks[this.center._id] = { count: 0, add: 0, };
                }
                
                if (p.name == name)
                {
                    return p;
                }
            }
            return null;
        },
        addProduct(name, count, memo) {
            const p = this.findProduct(name);
            if (p) {
                this.products.push({
                    _id: p._id,
                    name: p.name,
                    stock: p.centerStocks[this.center._id].count,
                    count: count,
                    memo: memo ? memo : "",
                });
                this.$forceUpdate();
            }
        },
        removeProduct(product) {
            let index = this.products.indexOf(product);
            if (index > -1) { this.products.splice(index, 1); }
        },
        loadExcelFile() {
            this.fileName = event.target.files[0].name;
            this.$event.call("openLoading");
            this.$excel.readFile(event.target.files[0], (excelData) => {
                this.$event.call("closeLoading");
                this.products = [];
                for (const data of excelData) {
                    if (!data["상품명"]) { alert("상품명을 찾을 수 없습니다!"); this.products = []; break; }
                    if (!parseInt(data["수량"])) { alert("수량을 찾을 수 없습니다!"); this.products = []; break; }
                    if (!this.findProduct(data["상품명"])) { alert(data["상품명"] + ": 등록되지 않은 상품입니다!"); this.products = []; break; }

                    this.addProduct(data["상품명"], parseInt(data["수량"]), data["메모"]);
                }
                this.reloadFile();
            });
        },

    },
    computed: {
        centers: function() { return this.$store.getters.centers; },
        partners: function() { return this.$store.getters.partners; },
        constant: function() { return this.$store.getters.constant; },
        constantNames: function() {return this.$store.getters.constantNames; },
    },
}
</script>

<style>
#stock_new_modal {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#stock_new_modal .column {
    min-width: 900px;
    max-width: 900px;
}

#stock_new_modal #header {
    padding: 20px 30px;
}

#stock_new_modal #body {
    padding: 50px;
}

#stock_new_modal #body .ui.form {
    padding: 10px;
}

#stock_new_modal #footer {
    padding: 20px 20px;
    background-color: #eee;
}

#stock_new_modal #footer .ui.text.menu {
    margin:0;
}

#stock_new_modal .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/StockModal_New.vue